var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import BasicElement from '../../../components/Elements/Basic';
import { getMaxDate, getMinDate } from '../../../utils/date';
var Element = function (props) {
    var id = props.id, time = props.time, style = props.style, _a = props.title, title = _a === void 0 ? '' : _a, _b = props.titleStyle, titleStyle = _b === void 0 ? {} : _b, start = props.start, end = props.end, classes = props.classes, _c = props.dataSet, dataSet = _c === void 0 ? {} : _c, tooltip = props.tooltip, tooltipFollowCursor = props.tooltipFollowCursor, _d = props.tooltipStyle, tooltipStyle = _d === void 0 ? {} : _d, altId = props.altId, clickElement = props.clickElement, continuing = props.continuing;
    var handleClick = function () {
        if (clickElement) {
            clickElement(props);
        }
    };
    var styleLeftAndWidth = time
        ? time.toStyleLeftAndWidth(getMaxDate(start, time.start), getMinDate(end, time.end))
        : {};
    var elementStyle = __assign(__assign({}, styleLeftAndWidth), (clickElement ? { cursor: 'pointer' } : {}));
    return (_jsx("div", __assign({ className: "rt-track__element", style: elementStyle, onClick: clickElement && handleClick }, { children: _jsx(BasicElement, { id: id, title: title, titleStyle: titleStyle, start: start, end: end, style: style, classes: classes, dataSet: dataSet, tooltip: tooltip, tooltipFollowCursor: tooltipFollowCursor, tooltipStyle: tooltipStyle, altId: altId, continuing: continuing }) })));
};
export default Element;
